import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function ActivityTracker() {
  const { user } = useAuth();
  const location = useLocation();
  const queue = useRef([]);
  const active = !!user && !user.is_admin;
  const firstView = useRef(true);

  useEffect(() => {
    if (firstView.current) { firstView.current = false; return; }
    if (window.fbq) { window.fbq("track", "PageView"); }
  }, [location.pathname]);

  useEffect(() => {
    if (!active) { return; }
    queue.current.push({ type: "page_view", path: location.pathname, target: location.pathname });
  }, [active, location.pathname]);

  useEffect(() => {
    if (!active) { return undefined; }
    const onClick = (e) => {
      const el = e.target.closest("[data-testid]");
      if (!el) { return; }
      const label = (el.innerText || "").trim().slice(0, 40);
      queue.current.push({ type: "click", path: window.location.pathname, target: label ? `${label} (${el.dataset.testid})` : el.dataset.testid });
    };
    const flush = () => {
      if (!queue.current.length) { return; }
      const events = queue.current.splice(0, 50);
      api.post("/activity/track", { events }).catch(() => {});
    };
    document.addEventListener("click", onClick, true);
    const t = setInterval(flush, 8000);
    window.addEventListener("beforeunload", flush);
    return () => { document.removeEventListener("click", onClick, true); clearInterval(t); window.removeEventListener("beforeunload", flush); flush(); };
  }, [active]);

  return null;
}
